import { EventEmitter, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';
import { FIXED_LOCAL_MODULES, LOCAL_MODULES } from '@modules/application/constants/module.constants';
export class ApplicationLateralSideComponent {
    constructor(moduleService) {
        this.moduleService = moduleService;
        this.closeSession = new EventEmitter();
        this.showResponsiveMenu = new EventEmitter();
        this.menusList = [];
        this.profile = {};
        this.availableModules$ = this.moduleService.modules$.pipe(map((remoteModules) => {
            const remoteIdentifiers = remoteModules.map((m) => m.identifier);
            const availableModules = LOCAL_MODULES.reduce((acc, localModule) => {
                if (!remoteIdentifiers.includes(localModule.code))
                    return acc;
                const remoteModule = remoteModules.find((m) => m.identifier === localModule.code);
                return [
                    ...acc,
                    Object.assign({}, localModule, remoteModule),
                ];
            }, []);
            return FIXED_LOCAL_MODULES.concat(availableModules.sort((a, b) => a.name.localeCompare(b.name)));
        }));
    }
    ngOnInit() {
        this.getAppHeight();
        this.profile.info = {};
    }
    onResize(event) {
        this.getAppHeight();
    }
    getAppHeight() {
        this.navHeight = `${window.innerHeight - 50}px`;
    }
}
